<!-- <div *ngIf ="isEnable; else elseBlock"> -->

<header>
  <app-header [headerName]=headerName></app-header>
</header>
<div *ngIf="showSpinner" class="spinner-overlay">
  <app-spinner></app-spinner>
</div>
<section>
  <div class="outer-conatiner">
     <div class="inner-container form-container">
      <app-page-title pageTitle='Village of Volo Overnight Parking'></app-page-title>
        <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
        <div class="container-wrapper">
           <mat-form-field>
              <mat-label>User Name</mat-label>
              <input type="text" formControlName="userName" matInput/>
              <mat-error *ngIf="signInForm.get('userName').hasError('required')">
               Please enter user name
             </mat-error> 
           </mat-form-field>
           <!-- <mat-form-field appearance="fill" *ngIf="isVillageStaff">
            <mat-label>Email Id</mat-label>
            <input placeholder="Enter Email" type="email" formControlName="email" autofil="email" matInput/>
            <mat-error *ngIf="signInForm.get('email').hasError('required')">
               Please enter Email
             </mat-error>
             <mat-error *ngIf="signInForm.get('email').errors?.email && !signInForm.get('email').errors?.required">
               Please enter Email
             </mat-error>
         </mat-form-field> -->
           <mat-form-field >
              <mat-label>Password</mat-label>
              <input  #passwordField  type="password" matInput formControlName="password"/> 
              <span *ngIf="changeCount > 3" toggle="#password-field"
                class="fa password-visible field-icon toggle-password"
                [title]="showPassword ? 'hide password' : 'show password'"
                [ngClass]="{'fa-eye': showPassword, 'fa-eye-slash': !showPassword}"
                (click)="togglePassword()"></span>
              <mat-error *ngIf="signInForm.get('password').hasError('required')">
               Please enter password
             </mat-error>
           </mat-form-field>
             <div style="display: block;">
          <div><span class="forgot-pwd"><a color="vov-ui-primary semi-button" (click)="forgotPassword()">Forgot Password</a></span> </div> 
        
           <div style="clear: both;padding-bottom:10px;"><button mat-button class="button-primary" [disabled]='signInForm.invalid' type="submit" color="vov-ui-primary">Sign In</button></div>
           <span ><a style="padding:22px;text-decoration: none; color: #6A0721;
            font-weight: bold;"  [routerLink]="" color="vov-ui-primary" (click)="reset()">Reset</a></span> 
            </div>
        </div>
      </form>
     </div>
  </div>
</section>
<footer></footer>

<!-- </div> -->
<!-- <ng-template #elseBlock> -->
  <!-- <header>
    <app-header [headerName]=headerName></app-header>
  </header> -->
  <!-- <section class="sign-in-btns"> 
    <div class="sign-in-info">
    <app-page-title pageTitle='Village of Volo Overnight Parking Database'></app-page-title><br>
    <div style="display: flex;align-items: center;">
    <div style="clear: both;margin-right: 10px;"><button mat-button class="button-primary"  (click)="gotoAdmin()" type="submit" color="vov-ui-primary">Admin</button></div>
    <div style="clear: both;margin-right: 10px;"><button mat-button class="button-primary" (click)="gotoVillageStaff()" type="submit" color="vov-ui-primary">Village staff</button></div>
    <div style="clear: both;"><button mat-button class="button-primary" (click)="gotoOfficer()" type="submit" color="vov-ui-primary">Officer</button></div>
  </div> -->
    <!-- <button  (click)="gotoAdmin()">Admin</button>
    <button  (click)="gotoVillageStaff()">Village staff</button>
    <button  (click)="gotoOfficer()">Officer</button> -->
    <!-- <div class="nav-link"><span style="padding-right: 10px;" class="txt-black">Having Trouble?</span>Get Help</div> -->
  <!-- </div>
  </section>
</ng-template> -->